import React from 'react';
import styled from 'styled-components';

export const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
`;
